
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2StarterPackageBuyConfirmationDialogProperties } from "./Poker2StarterPackageBuyConfirmationDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2StarterPackageBuyConfirmationDialog extends Poker2Dialog {
    public static NAME: string = "Poker2StarterPackageBuyConfirmationDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.dialogTemplate.txt_title.text = Poker2Model.languageData.getTextById("generic_alert_information");
        this.dialogTemplate.txt_copy.text = Poker2Model.languageData.getTextById("dialog_bundles_purchaseconfirmation_text");

        // btn back
        this.dialogTemplate.btn_back.label = Poker2Model.languageData.getTextById("generic_btn_goback");

        // btn buy
        this.dialogTemplate.btn_deeplink.label = Poker2Model.languageData.getTextById("dialog_bundles_purchaseconfirmation_buybutton");
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.dialogTemplate.btn_back:
            case this.dialogTemplate.btn_close:

                this.hide();
                break;

            case this.dialogTemplate.btn_deeplink:

                var paramObject: any = { id: this.dialogProperties.starterPackageId };
                BasicModel.smartfoxClient.sendMessage(SFConstants.C2S_BUY_STARTER_PACKAGE, [JSON.stringify(paramObject)]);

                this.hide();
                break;
        }
    }

    private get dialogProperties(): Poker2StarterPackageBuyConfirmationDialogProperties {
        return this.properties as Poker2StarterPackageBuyConfirmationDialogProperties;
    }

    private get dialogTemplate(): Library.PokerInterface.PokerStarterPackageBought {
        return this.disp as Library.PokerInterface.PokerStarterPackageBought;
    }
}
